import React from "react";
import "../App.css";
import CarteComplete from "../Components/CarteComplete";

export default function Carte() {
  window.scrollTo(0, 0);
  return (
    <div>
      <CarteComplete />
    </div>
  );
}
